<div class="row g-0">
    <div class="col-12">
        <div class="card-body">
            <jft-select-current-contract
                      [tender]="tender"
                      (onUpdated)="onUpdated($event)">
              </jft-select-current-contract>
        </div>
    </div>
</div>
